import UpdateValue from './UpdateValue';
import { UpdateValueProps, UpdateValueValueProps } from './types';

export type { UpdateValueProps, UpdateValueValueProps };
export default UpdateValue;
